import { TFunc } from '../i18n/types';
import { parseLocationToObject } from '@Utils/parseLocation';
import * as yup from 'yup';

const nameSchema = (t: TFunc) => yup.string().required(t('Name is required'));

const typeSchema = (t: TFunc) => yup.string().required(t('Type is required'));

const sensorOrSensorGroupShape = yup.string();
const sensorOrSensorGroupSchema = (t: TFunc) =>
	yup.array().of(sensorOrSensorGroupShape).min(
		1,
		t(
			// eslint-disable-next-line quotes
			"Fields 'Data Sources' and 'Sensor Groups' cannot be empty at the same time.",
		),
	);

const sensorGroupsSchema = (t: TFunc) =>
	yup.mixed().when('sensors', {
		is: (sensorGroupId: string[]) => !sensorGroupId?.length,
		then: sensorOrSensorGroupSchema(t),
	});

const sensorsSchema = (t: TFunc) =>
	yup.mixed().when('sensorGroups', {
		is: (sensorGroupId: string[]) => !sensorGroupId?.length,
		then: sensorOrSensorGroupSchema(t),
	});
const locationSchema = (t: TFunc) =>
	yup
		.string()
		.test(
			'validLocation',
			t('Invalid Location'),
			location =>
				!location || parseLocationToObject(location) !== undefined,
		);

const liftStationShape = (t: TFunc) => ({
	name: nameSchema(t),
	type: typeSchema(t),
	location: locationSchema(t),
	sensorGroups: sensorGroupsSchema(t),
	sensors: sensorsSchema(t),
	outflowPipeDiameter: yup.number().nullable(true),
	wellThreshold: yup.number().nullable(true),
});

export const liftStationSchema = (t: TFunc) =>
	yup.object().shape(liftStationShape(t), [['sensors', 'sensorGroups']]);
